import { BrowserModule } from "@angular/platform-browser";
import { LOCALE_ID, NgModule } from "@angular/core";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { InicioComponent } from "./components/visitor/inicio/inicio.component";
import { HeaderComponent } from "./components/visitor/header/header.component";
import { CadastroComponent } from "./components/visitor/cadastro/cadastro.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgxMaskModule } from "ngx-mask";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { MainComponent } from "./components/logado/main/main.component";
import { HttpClientModule } from "@angular/common/http";
import { ServerRoutes } from "./ServerRoutes";
import { HomeComponent } from './logado/home/home.component';
import { InicioLogadoComponent } from './components/logado/inicio-logado/inicio-logado.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { AgendaComponent } from './components/logado/agenda/agenda.component';
import { PerfilComponent } from './components/logado/perfil/perfil.component';
import { AtendimentoComponent } from './components/logado/atendimento/atendimento.component';
import { EsqueciSenhaComponent } from './components/visitor/esqueci-senha/esqueci-senha.component';
import { VideocallComponent } from './components/logado/videocall/videocall.component';
import { SingleClienteComponent } from './components/logado/single/single-cliente/single-cliente.component';
import { AgendaEspecificaComponent } from './components/logado/agenda-especifica/agenda-especifica.component';
import { FinanceiroComponent } from './components/logado/financeiro/financeiro.component';
import { MatTableModule, MatIconModule } from "@angular/material";
import { CookieService } from 'ngx-cookie-service';
import { AcceptCookiesComponent } from './components/accept-cookies/accept-cookies.component';
import { LgpdComponent } from './components/lgpd/lgpd.component';
import { SimpleModalModule } from "ngx-simple-modal";
import { PlanoComponent } from './components/logado/plano/plano.component';
import { CarrinhoPlanoComponent } from './components/logado/carrinho-plano/carrinho-plano.component';
import { PagamentosComponent } from './components/logado/pagamentos/pagamentos.component';
import { QRCodeModule } from "angularx-qrcode";
import { TablePlansComponentComponent } from './components/logado/table-plans-component/table-plans-component.component';
import { PagarPlanoComponent } from './components/logado/pagar-plano/pagar-plano.component';
import { PixComponentComponent } from './components/logado/pagamentos/pix-component/pix-component.component';
import { BoletoComponentComponent } from './components/logado/pagamentos/boleto-component/boleto-component.component';
import { LoadingPageComponent } from './components/helpers/loading-page/loading-page.component';
import { DefaultModalComponent } from './components/helpers/default-modal/default-modal.component';
import ptBr from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { DadosBancariosComponent } from './components/logado/dados-bancarios/dados-bancarios.component';
import { DefaultModalConfirmationComponent } from './components/helpers/default-modal-confirmation/default-modal-confirmation.component';
import { NotFoundPageComponent } from './components/not-found-page/not-found-page.component';
import { CashBackComponent } from "./components/logado/cash-back/cash-back.component";
import { ModalCashBackComponent } from "./components/helpers/modal-cash-back/modal-cash-back.component";

registerLocaleData(ptBr);

@NgModule({
  declarations: [
    AppComponent,
    InicioComponent,
    HeaderComponent,
    CadastroComponent,
    MainComponent,
    HomeComponent,
    InicioLogadoComponent,
    AgendaComponent,
    PerfilComponent,
    AtendimentoComponent,
    EsqueciSenhaComponent,
    VideocallComponent,
    SingleClienteComponent,
    AgendaEspecificaComponent,
    FinanceiroComponent,
    AcceptCookiesComponent,
    LgpdComponent,
    PlanoComponent,
    CarrinhoPlanoComponent,
    PagamentosComponent,
    TablePlansComponentComponent,
    PagarPlanoComponent,
    PixComponentComponent,
    BoletoComponentComponent,
    LoadingPageComponent,
    DefaultModalComponent,
    DadosBancariosComponent,
    DefaultModalConfirmationComponent,
    NotFoundPageComponent,
    CashBackComponent,
    ModalCashBackComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    HttpClientModule,
    FullCalendarModule,
    MatTableModule,
    MatIconModule,
    SimpleModalModule,
    QRCodeModule,
  ],
  providers: [ServerRoutes, CookieService, { provide: LOCALE_ID, useValue: 'pt' }],
  bootstrap: [AppComponent],
  entryComponents: [
		LgpdComponent,
    DefaultModalComponent,
    DefaultModalConfirmationComponent,
    ModalCashBackComponent
	]
})
export class AppModule {}
